export default {
  logoutButton: {
    en: "Logout",
    ja: "ログアウト"
  }
}
